import { getNodeByTreePath, getTreePathOfNode } from 'anodum';
import textFormatting from '../../text-formatting';

const createClonedSelectionData = (contentEditable) => {
  const clonedContentEditable = contentEditable.cloneNode(true);
  const selection = textFormatting.accessors.getAdvancedSelection();
  const { anchorNode, anchorOffset } = selection;

  const anchorNodePath = getTreePathOfNode(anchorNode, contentEditable);

  return {
    clonedContentEditable,
    clonedSelectionData: {
      node: getNodeByTreePath(clonedContentEditable, anchorNodePath),
      offset: anchorOffset,
    },
  };
};

export default createClonedSelectionData;
